import login from './login/index.vue'
import loginCorporate from './login/corporate.vue'
import passwordChange from './new-password'
import airlineCheckin from '../airline-checkin/index.vue'

export default [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      guest: true
    }
  },
  {
    path: '/airline-checkin/:airlineCode',
    name: 'airlineCheckin',
    component: airlineCheckin,
    meta: {
      guest: true
    }
  },
  {
    path: '/corporate',
    name: 'loginCorporate',
    component: loginCorporate,
    meta: {
      guest: true
    }
  },
  {
    path: '/password/:token',
    name: 'passwordChange',
    component: passwordChange,
    meta: {
      guest: true
    }
  }
]
